let screenW = $(window).width()
let screenH = $(window).height()

function breakpoint(breakpoint)
{
  let breakpoints = {
    'xs': 0,
    'sm': 620,
    'md': 768,
    'lg': 976,
    'xl': 1024,
    'xln': 1280,
    'xxl': 1920,
    'screenW': screenW,
    'screenH': screenH,
  }
  return breakpoints[breakpoint]
}

function breakpointUp(value)
{
  return breakpoint('screenW') >= breakpoint(value)
}

function breakpointDown(value)
{
  return breakpoint('screenW') < breakpoint(value)
}

function screenSizeCoefficient()
{
  let coefficient = 1
  if (breakpoint('screenW') > breakpoint('xxl')) {
    coefficient = breakpoint('screenW') /  breakpoint('xxl')
  }

  coefficient = coefficient < 0.7 ? 0.7 : coefficient

  return coefficient
}

export { breakpoint, screenSizeCoefficient, breakpointUp, breakpointDown }
